module.exports = __webpack_public_path__ + "img/play.1124d112.png";